module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/login/select_on.png";